/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { h100css } from "assets/css/dimensions";
import { lineClamp1Css } from "assets/css/lineClamp.css";
import Popper from "components/common/Popper";
import copyToClipboard from "helpers/copyToClipboard";

export default function StringCell({ value, className, disableLineClamp = false }) {
  if (!value) return null;
  return (
    <div css={h100css} className={`flex-a-c${className ? ` ${className}` : ""}`}>
      <Popper text={value}>
        <button type="button" onClick={copyToClipboard(value)} className={className}>
          <span css={disableLineClamp ? undefined : lineClamp1Css}>{value}</span>
        </button>
      </Popper>
    </div>
  );
}

StringCell.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  disableLineClamp: PropTypes.bool,
};
